import { Alert } from "../Alert"

export interface Props {
  children?: string
  className?: string
}

// TODO: Container with status color and icon, dismissable

export function FormErrorText({ children, className }: Props) {
  return (
    <div className={className}>
      <Alert status="critical" text={children || ""} />
    </div>
  )
}
